import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { WHITE, PG, SLB, PG10S, SLB10S } from '@h2/components/colors'
import { Text } from '@h2/components/typography/text'

const bgColors = {
  green: PG,
  blue: SLB
}
const hoverBgColors = {
  green: PG10S,
  blue: SLB10S
}
const Wrap = styled.div`
  width: 100%;
  height: 27px;
  margin-top: 5px;
`
const StyledLink = styled(Link)`
  &:link,
  &:active,
  &:visited {
    height: 100%;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ color }) => bgColors[color]};
    border-radius: 4px;
    cursor: pointer;
    text-decoration: none;
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 5px auto blue;
    outline-offset: -2px;
  }
  &:hover {
    color: ${WHITE};
    background-color: ${({ color }) => hoverBgColors[color]};
  }
  &:disabled {
    color: #ccc;
    cursor: default;
  }
`
const AnchorButton = ({ children, color = 'green', ...props }) => (
  <Wrap>
    <StyledLink color={color} {...props}>
      <Text color={WHITE} weight="bold" margin="0" size="medium">
        {children}
      </Text>
    </StyledLink>
  </Wrap>
)

AnchorButton.propTypes = {
  color: PropTypes.oneOf(['green', 'blue'])
}

export { AnchorButton }
